module.exports = __webpack_public_path__ + "img/pantalla-9-2.285ac380.png";